
import React, { Component } from 'react'

export default function asyncComponent(importComponent) {

    class AsyncCompoent extends Component {

        constructor(props) {
            super(props);
        }

        state = {
            component: null,
        }

        async componentDidMount () {
            console.log(importComponent);
            const { default: component } = await importComponent;
            // console.log({component});
            this.setState({
                component: component,
            });
        }

        render () {
            const C: any = this.state.component;
            console.log(C);
            return C ? <C {...this.props} /> : null;
        }
    }

    return AsyncCompoent;
}